import { HeaderConfig} from '@qai/ui';
import { TranslocoService } from '@jsverse/transloco';

export const getPracticeUsersTableHeaders = (transloco: TranslocoService): HeaderConfig[] => {
  const translateHeader = (key: string) => transloco.translate(key, {}, 'reportingV2');

  return [
    {
      name: translateHeader('NAME_LABEL'),
      sortable: true,
      columnWidth: '10%',
      clickable: true,
    },
    {
      name: translateHeader('EMAIL_LABEL'),
      sortable: true,
      columnWidth: '12%',
    },
    { name: translateHeader('TEAM_LABEL'), sortable: true, columnWidth: '11%' },
    {
      name: translateHeader('ENGAGEMENT_STATUS_LABEL'),
      sortable: true,
      columnWidth: '13%',
    },
    {
      name: translateHeader('NUMBER_OF_SESSIONS_LABEL'),
      sortable: true,
      columnWidth: '10%',
    },
    {
      name: translateHeader('INITIAL_SCORE_LABEL'),
      sortable: true,
      columnWidth: '11%',
    },
    {
      name: translateHeader('HIGH_SCORE_LABEL'),
      sortable: true,
      columnWidth: '9%',
    },
    {
      name: translateHeader('AVERAGE_SCORE_LABEL'),
      sortable: true,
      columnWidth: '10%',
    },
    {
      name: translateHeader('PERCENT_IMPROVED_LABEL'),
      icon: 'help-circle',
      tooltip: translateHeader('PERCENT_IMPROVED_TOOLTIP_TEXT'),
      sortable: true,
      columnWidth: '14%',
    },
  ];
};

export const getCertificationUsersTableHeaders = (
  transloco: TranslocoService
): HeaderConfig[] => {
  const translateHeader = (key: string) =>
    transloco.translate(key, {}, 'reportingV2');

  return [
    { name: translateHeader('NAME_LABEL'), sortable: true, columnWidth: '13%', clickable: true },
    { name: translateHeader('EMAIL_LABEL'), sortable: true, columnWidth: '13%' },
    { name: translateHeader('TEAM_LABEL'), sortable: true, columnWidth: '12%' },
    { name: translateHeader('CERTIFICATION_STATUS_LABEL'), sortable: true, columnWidth: '16%' },
    { name: translateHeader('CERTIFIED_ON_FIRST_ATTEMPT_LABEL'), sortable: true, columnWidth: '18%' },
    { name: translateHeader('DATE_OF_CERTIFICATION_LABEL'), sortable: true, columnWidth: '16%' },
    { name: translateHeader('HIGH_SCORE_LABEL'), sortable: true, columnWidth: '12%' },
  ];
};

export const getUsersTabTableHeaders = (transloco: TranslocoService): HeaderConfig[] => {
  const translateHeader = (key: string) => transloco.translate(key, {}, 'reportingV2');

  return [
      { name: translateHeader('NAME_LABEL'), sortable: true, columnWidth: '8%' },
      { name: translateHeader('EMAIL_LABEL'), sortable: true, columnWidth: '11%' },
      { name: translateHeader('MEMBER_OF_TEAMS_LABEL'), sortable: true, columnWidth: '11%' },
      { name: translateHeader('ASSIGNMENTS_COUNT_LABEL'), sortable: true, columnWidth: '12%' },
      { name: translateHeader('TOTAL_SESSIONS_LABEL'), sortable: true, columnWidth: '10%' },
      { name: translateHeader('AVERAGE_SCORE_LABEL'), sortable: true, columnWidth: '9%' },
      { name: translateHeader('LAST_PRACTICE_DATE_LABEL'), sortable: true, columnWidth: '10%' },
      { 
        name: translateHeader('ASSIGNMENTS_CERTIFIED_LABEL'),
        icon: 'alert-circle',
        tooltip: translateHeader('ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT'),
        sortable: true,
        columnWidth: '14%' 
      },
      { 
        name: translateHeader('ASSIGNMENTS_PROFICIENT_LABEL'), 
        icon: 'help-circle', 
        tooltip: translateHeader('ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT'),
        sortable: true,
        columnWidth: '15%' 
      },
    ];
};
